import React from 'react'
import {Divider, Flex, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {remCalc} from '../../../overrides/app/theme/_utils'
import PropTypes from 'prop-types'

const HeadingComponentName = ({name, description}) => {
    const componentName = '<' + name + ' />'
    return (
        <Flex flexDir="column" padding={`${remCalc(40)} ${remCalc(40)} ${remCalc(0)}`}>
            <Text
                textStyle={'head-xsmall'}
                fontWeight={'regular'}
                color={'text.disable'}
                mb={remCalc(10)}
            >
                component
            </Text>
            <Text textStyle={'head-large'} fontWeight={'bold'}>
                {componentName}
            </Text>
            {description && (
                <Text textStyle={'head-xxsmall'} fontWeight={'regular'} mt={remCalc(20)}>
                    {description}
                </Text>
            )}
            <Divider mt={remCalc(40)} />
        </Flex>
    )
}

HeadingComponentName.propTypes = {
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
}

export default HeadingComponentName
